import { FC } from 'react';
import { Input } from 'antd';
import Modal from 'Components/Modal/Modal';
import { Button } from 'Components';
import styles from './ModalForm.module.scss';
import useLogin from '../Hooks/LoginHooks';

interface Props {
	visible: boolean;
	onCancel: () => void;
}

const AdminLoginModal: FC<Props> = ({ visible, onCancel }) => {
	const formik = useLogin(); // now returns formik

	return (
		<Modal
			visible={visible}
			centered
			onCancel={onCancel}
			footer={null}
			size="xs"
		>
			<div className={styles.container}>
				<div className={styles.title}>Venza Admin Sign-In</div>

				<form onSubmit={formik.handleSubmit}>
					<div className={styles.field}>
						<label>Username</label>
						<Input
							name="username"
							placeholder="Enter your username"
							size="large"
							value={formik.values.username}
							onChange={formik.handleChange}
							onBlur={formik.handleBlur}
							onPressEnter={() => formik.submitForm()}
							disabled={formik.isSubmitting}
						/>
						{formik.touched.username && formik.errors.username && (
							<div className={styles.errorMsg}>
								{formik.errors.username}
							</div>
						)}
					</div>

					<div className={styles.field}>
						<label>Password</label>
						<Input
							name="password"
							type="password"
							placeholder="Enter your password"
							size="large"
							value={formik.values.password}
							onChange={formik.handleChange}
							onBlur={formik.handleBlur}
							onPressEnter={() => formik.submitForm()}
							disabled={formik.isSubmitting}
						/>
						{formik.touched.password && formik.errors.password && (
							<div className={styles.errorMsg}>
								{formik.errors.password}
							</div>
						)}
					</div>

					<Button
						type="primary"
						shape="round"
						className="cta-prominent"
						htmlType="submit"
						style={{ marginTop: '16px' }}
						loading={formik.isSubmitting}
						disabled={formik.isSubmitting}
					>
						Log in
					</Button>
				</form>

				{/* API error */}
				{formik.status && (
					<div className={styles.errorMsg}>{formik.status}</div>
				)}

				<div className={styles.helperText}>
					This page is for Venza admins only. Client administrators
					must log in through their portal.
				</div>
			</div>
		</Modal>
	);
};

export default AdminLoginModal;
